export default {
  ma_back_to_cart: 'Back to cart',
  ma_copy_link: 'Copy link',
  ma_link_copied: 'Link copied!',
  ma_share_email: 'Share via email',
  ma_share_email_mobile: 'Email',
  ma_share_whatsapp: 'Share on Whatsapp',
  ma_share_whatsapp_mobile: 'Whatsapp',
  ma_not_found_title: 'Sorry, order number not found.',
  ma_not_found: 'The order number you\'re looking for doesn\'t exist.',
  ma_go_homepage: 'Go to homepage',
  ma_item_canceled: 'Item canceled',
  ma_qty: 'Qty',
  ma_filetype_not_supported: 'This file type is not supported.',
  ma_prescription_file_size_error: 'This file size is too big.',
  ma_select_file: 'Select file',
  ma_notification_sent: 'You will receive an email when this product will be available again.',
  ma_menu_wishlist: 'Wishlist',
  ma_menu_your_loyalty_program: 'Loyalty Program',
  ma_menu_search: 'Search',
  ma_menu_cart: 'Cart',
  ma_menu_user_icon: 'My Account User Icon',
  ma_menu_user_icon_logged: 'My Account User Icon logged',
  ma_click_order_details: 'Click order details to track each parcel.',
  ma_order: 'Order',
  ma_phone: 'Phone',
  ma_size: 'Size',
  ma_thank_you: 'Thank you!',
  ma_send: 'Send',
  ma_loading: 'Loading',
  ma_engraving: 'Engraving',
  ma_customized: 'Customized',
  ma_engraving_case: 'Engraving case',
  ma_details_product_case: 'Case',
  ma_details_product_case_electronics: 'Charger included',
  ma_temple_tips: 'Temple tips',
  ma_font_01: 'Regular',
  ma_font_02: 'Italic',
  ma_font_03: 'Bold',
  ma_font_16: 'Calligraphy 1',
  ma_font_17: 'Calligraphy 2',
  ma_font_18: 'Calligraphy 3',
  ma_color_silver: 'Silver',
  ma_details_product_sn: 'Serial number',
  ma_sup_not_alpha_message: 'Make sure to only use numbers',
  ma_join_loyalty: 'Join Loyalty Program',
  ma_email_restock:
    'Insert your email If you want to be informed when this product will be back in stock',
  ma_email_notification:
    'You will receive a notification if the product will be available in the next 30 days.',
  ma_mandatory: 'This field is required',
  ma_sup_title: 'Join The Sun Club',
  ma_sup_title_join: 'Create an account',
  ma_sup_new_account: 'Sign up and join us',
  ma_sup_title_loyalty: 'Congrats, you’re part of The Sun Club!',
  ma_sup_subtitle: 'Create an account to check your points balance and redeem benefits.',
  ma_sup_new_account_loyalty: 'Sign up and join us',
  ma_sup_subscribe_info: 'Marketing / Subscribe to The Ones Program',
  ma_sup_mail_title: 'NEWSLETTER SUBSCRIPTION',
  ma_sup_marketing_subscribe_message:
    'By checking the box, you consent to receive emails about our latest collections and exclusive offers. You can change your mind and unsubscribe any time. By proceeding you confirm that you’ve read and understood our {placeholderLink}.',
  ma_sup_loyalty_title: 'LOYALTY PROGRAM',
  ma_sup_loyalty_subscribe_message:
    'By clicking the button, I affirm I am a US Resident, at least 18 years old, and consent to subscribing and receiving marketing messages from & about The Sun Club Loyalty Program. I have been provided the {placeholderLink} and {placeholderIncentives} and agree to {placeholderLinkTerm}.',
  ma_sup_sms_title: 'PHONE COMMUNICATIONS',
  ma_sup_marketing_subscribe_sms:
    'By checking the box, I provide my signature expressly consenting to contact at the number I provided SunglassHut regarding products or services, including marketing and promotions, via live or automated telephone call, text and agree to the information provided at the following links {placeholderLinkTerm} & {placeholderLink}. {placeholderSubscribe}',
  ma_sup_marketing_subscribe_sms_revoke:
    'I understand I am not required to enter into this agreement as a condition of any purchase and that I can revoke this consent to text messages by texting STOP or replying HELP for help. Please note message frequency varies and message and data rates may apply.',
  ma_sup_mandatory: 'This field is required',
  ma_surname_error: 'Please provide your last name',
  ma_sup_no_to_say_option: 'Prefer not to say',
  ma_sup_signup: 'Sign up ',
  ma_sup_login: 'Log in ',
  ma_sup_optin_all: 'Email and SMS',
  ma_sup_optin_email: 'Email only',
  ma_sup_optin_sms: 'SMS only',
  ma_sup_optin_contact: 'Contact me via',
  ma_sup_create_account: 'Sign up and join us',
  ma_sup_exclusives:
    'Create an account and join our loyalty program! As a member you\'ll enjoy special benefits & exclusive products.',
  ma_sup_email: 'Email address',
  ma_sup_firstName: 'First name',
  ma_sup_lastName: 'Last name',
  ma_sup_show: 'Show',
  ma_sup_hide: 'Hide',
  ma_password_requirments: 'Passwords should be between 6 and 12 characters',
  ma_sup_gender_select_message: 'Select your gender:',
  ma_sup_female: 'Female',
  ma_sup_male: 'Male',
  ma_sup_birthdate_filled: 'Birthday MM/DD/YYYY',
  ma_sup_day: 'Day',
  ma_sup_month: 'Month',
  ma_sup_year: 'Year',
  ma_sup_birthdate: 'Birthday',
  ma_sup_special_gift: 'We’ll send you a special gift on your birthday! ',
  ma_sup_phoneNumber: 'Phone number',
  ma_sup_updates:
    'Sign up for updates and exclusive offers. Change your mind and unsubscribe any time. Privacy Policy',
  ma_sup_privacy_policy_url: '/us/sunglasses/privacy-policy',
  ma_sup_privacy_policy_loyalty_url: '/us/sunglasses/privacy-policy#cm-420200',
  ma_sup_privacy_policy: 'Privacy Policy',
  ma_sup_loyalty_incentives: 'Notice of Financial Incentives',
  ma_sup_loyalty_incentives_url: '/us/sunglasses/privacy-policy#cm-419118',
  ma_sup_privacy_terms: 'Terms of Use',
  ma_sup_privacy_terms_url: '/us/sunglasses/terms',
  ma_sup_email_marketing:
    'Sign up to receive product news and exclusive offers from Sunglass Hut. You can withdraw consent at any time. For more details see our {placeholderLink}. I certify that I am 18 years or older',
  ma_typ_start_shopping: 'Start shopping',
  ma_lip_email: 'Email address',
  ma_lip_password: 'Password',
  ma_lip_new_account: 'Create your account',
  ma_lip_signup: 'Sign up with email',
  ma_lip_description:
    'Lorem ipsum dolor sit amet Lorem ipsum dolor sit ametLorem ipsum dolor sit ame Lorem ipsum dolor sit amet Lorem ipsum dolor sit ametLorem ipsum dolor sit ame',
  ma_lip_signingin: 'Signing in',
  ma_lip_invalid_password_message:
    'Your password must be between 6 and 12 characters long and is case sensitive',
  ma_lip_show_password: 'Show',
  ma_lip_hide_password: 'Hide',
  ma_lip_mandatory: 'This field is required',
  ma_lip_remember_me: 'Remember me',
  ma_lip_forgot_password: 'Forgot your password?',
  ma_lip_login: 'Log in',
  ma_lip_newHere: 'New here? Join us!',
  ma_lip_priority_access:
    'Take advantage of exclusive offers,<br> priority access and special services<br> when you become a Sunglass Hut member! ',
  ma_lip_create_account: 'Sign up and join us',
  ma_pr_forgot_password: 'Forgot your password?',
  ma_pr_enter_email: 'Enter the email address associated with your account.',
  ma_pr_reset_password: 'Reset password',
  ma_pr_back_login: 'Back to login',
  ma_pr_email_sent: 'An email has been sent to {0}',
  ma_pr_check_inbox: 'If you have an account, you’ll find a reset link in your inbox.',
  ma_pr_reset_your_password: 'Reset your password',
  ma_pr_enter_new_password: 'Please enter your new password.',
  ma_pr_success_reset: 'Your password was reset successfully! Log into your account below.',
  ma_pr_password_specs:
    'Passwords must be between 6 and 12 characters long and are case sensitive.  ',
  ma_pr_newPassword: 'New password',
  ma_pr_confirmPassword: 'Confirm new password',
  ma_rpedm_forgot_password: 'FORGOT YOUR PASSWORD?',
  ma_rpedm_dont_sweat: 'Don’t sweat it, click below to set a new one. ',
  ma_rpedm_set_new_password: 'Set a new password',
  ma_rpedm_questions_or_comments: 'Questions or comments?',
  ma_rpedm_additional_info:
    'If you need additional information or assistance, visit our website or call us at 1.800.786.4527.',
  ma_PDPEX_login_add_to_bag: 'Log in and add to bag',
  ma_rpedm_already_have_account_login: 'Already have an account?',
  ma_menu_overview: 'Overview',
  ma_menu_ccare_link: 'Contact us',
  ma_order_status_url: 'https://www.sunglasshut.com/us/status',
  ma_menu_ccare_link_url: '/us/sunglasses/contact-us',
  ma_menu_services_link: 'Our services',
  ma_menu_services_link_url: '/us/sunglasses/services-for-you',
  ma_menu_terms_link: 'Terms & Conditions',
  ma_menu_terms_link_url: '/us/terms',
  ma_menu_shipping_link: 'Shipping and Delivery',
  ma_menu_shipping_link_url: '/us/shipping-delivery',
  ma_menu_title: 'My Account',
  ma_menu_welcome: 'Welcome back, {0}!',
  ma_menu_user: 'Hi, {0}!',
  ma_menu_user_mobile: 'Hi {0}',
  ma_menu_login: 'Log in ',
  ma_menu_create_account: 'Create Account',
  ma_menu_women: 'Women ',
  ma_menu_men: 'Men ',
  ma_menu_designers: 'Designers',
  ma_menu_rayban: 'Ray-Ban',
  ma_menu_giftcards: 'Gift cards',
  ma_menu_sunny_services: 'Sunny services',
  ma_wishlist: 'Wishlist',
  ma_frame_subtitle: 'Find the perfect frame',
  ma_menu_account: 'Account',
  ma_menu_details: 'Profile',
  ma_menu_orderHistory: 'Orders',
  ma_menu_returnHistory: 'Returns',
  ma_menu_get_an_appointment: 'In-store appointments',
  ma_menu_support: 'Get support',
  ma_menu_logout: 'Log out',
  ma_lo_new_here: 'New here? Join us! ',
  ma_lo_exclusive_offers:
    'Take advantage of exclusive offers,<br/> priority access and special services<br/> when you become a Sunglass Hut member! ',
  ma_lo_free_easy_returns: 'FREE AND EASY RETURNS',
  ma_lo_replacement_coverage: 'REPLACEMENT COVERAGE',
  ma_lo_perfect_fit: 'PERFECT FIT',
  ma_mm_add_giftcard: 'Add a gift card to your account',
  ma_mm_add_existing_giftcard: 'Add an existing gift card to your account and check your balance. ',
  ma_mm_add_card: 'Add card',
  ma_mm_buy_giftcard: 'Looking to buy a gift card?',
  ma_mm_shop_sgh_giftcards: 'Shop Sunglass Hut gift cards and e-gift cards',
  ma_mm_redeemable: 'redeemable online and in store.',
  ma_mm_shop_giftcards: 'Shop gift cards',
  ma_mm_shop_egiftcards: 'Shop e-gift cards',
  ma_ov_overview: 'Overview ',
  ma_mno_profile_details: 'Profile details ',
  ma_mno_orders: 'ORDERS',
  ma_mno_returns: 'Returns',
  ma_mno_giftcards: 'Gift cards',
  ma_mno_wishlist: 'Wishlist',
  ma_mno_appointments: 'In-store appointments',
  ma_mno_logout: 'Log out',
  ma_pb_created: 'Created',
  ma_pb_canceled: 'Canceled',
  ma_pb_in_progress: 'In progress',
  ma_pb_shipped: 'Shipped',
  ma_pb_delivered: 'Delivered',
  ma_pb_returned: 'Returned ',
  ma_pb_prescription: 'PRESCRIPTION TO BE VALIDATED',
  ma_pb_rejected: 'REJECTED',
  ma_pb_completed: 'COMPLETED',
  ma_menu_menu: 'Menu',
  ma_order_history: 'Order History',
  ma_track: 'View and track your orders and make returns.',
  ma_orders_search_by: 'If you cannot find an order, ',
  ma_orders_search_by_continues: ' to search with your order ID and email address.',
  ma_click_here: 'click here',
  ma_returns_search_by: 'If you cannot find a return, search with your ',
  ma_returns_search_by_link: 'order ID and email address.',
  ma_no_orders: 'You have not yet placed any orders. ',
  ma_support: 'Get support',
  ma_our_services: 'Our services',
  ma_terms: 'Terms & Conditions',
  ma_cancel_within: 'You can cancel within one hour of purchase.',
  ma_read_more: 'Read more',
  ma_multiple_shipments: 'Multiple shipments in this order',
  ma_delivery_date: 'You will find the delivery date for each item in the order details page.',
  ma_track_parcel:
    'Track each parcel in the order details page. You’ll find a button to track the shipment next to each item. ',
  ma_cancel_order: 'Cancel order',
  ma_order_number: 'Order Number',
  ma_order_total: 'Order Total ',
  ma_order_details: 'Order details',
  ma_order_in_progress: 'Order {0}: In progress',
  ma_omniOrder_being_processed: 'Your order is being processed. ',
  ma_order_being_processed: 'Your order is being processed and prepared to ship. ',
  ma_free_shipping: 'Free shipping,',
  ma_order_shipped: 'Order {0} - Shipped',
  ma_track_order: 'Track order',
  ma_order_awaiting_prescription: 'Order {0}: Awaiting prescription ',
  ma_cannot_prepare: 'We cannot prepare your order without a prescription.',
  ma_upload_or_send: 'Upload it below or send it to ',
  ma_customer_care: 'customercare@sgh.com',
  ma_prescription_glasses:
    'Prescription glasses will be delivered within <span>7 business days</span> upon receiving your prescription',
  ma_uplad_prescription: 'Upload prescription',
  ma_prescription_info: 'Pupillary Distance (PD) is required. If you do not know it please add the standard measurements of 61 for women and 64 for men.',
  ma_create_return: 'Create return',
  ma_order_delivered: 'Order {0}: Delivered',
  ma_order_been_delivered: 'Your order has been delivered to your address.',
  ma_resend_ecard: 'Resend e-card via email',
  ma_add_card: 'Add card to your profile',
  ma_order_canceled: 'Order {0}: Canceled',
  ma_order_been_canceled: 'Your order has been canceled.',
  ma_order_return_created: 'Order {0}: Return created',
  ma_return_limit: 'You can return this item until',
  ma_print_label: 'Print label',
  ma_file: 'file.pdf',
  ma_change: 'change',
  ma_accepted_formats: 'Accepted formats: jpg, pdf, png. Max size: 10MB',
  ma_prescription_uploaded: 'Prescription uploaded',
  ma_issue: 'Have an issue with your order?',
  ma_order_info: 'Order Information',
  ma_order_date: 'Order Date',
  ma_return_number: 'Return Number',
  ma_delivery_info: 'Delivery information',
  ma_delivery_address: 'Delivery Address ',
  ma_delivery_method: 'Delivery Method',
  ma_billing_address: 'Billing address',
  ma_delivered_within:
    'Delivered within <span>7 business days</span> upon receiving your prescription',
  ma_prescription: 'My lens choices',
  ma_prescription_use:'Use:',
  ma_prescription_lens:'Lens:',
  ma_prescription_thickness:'Thickness:',
  ma_prescription_treatments:'Treatments:',
  ma_frame: 'Frame',
  ma_lenses: 'Lenses',
  ma_price: 'Price',
  ma_subtotal: 'Subtotal',
  ma_discount: 'Discount',
  ma_shipping_and_handling: 'Shipping & Handling ',
  ma_tax: 'Tax',
  ma_verifying: 'Order {0} - Verifying your prescription',
  ma_we_will_process: 'We’ll process your order as soon as it’s verified. ',
  ma_order_created: 'Order {0} - Created',
  ma_cancel_limit: 'You can cancel within one hour of purchase. Read more',
  ma_product_information: 'Product Information',
  ma_order_progress: 'Order {0} - In progress',
  ma_order_been_shipped: 'Your order has been shipped and can be tracked below.  ',
  ma_download_invoice: 'Download invoice',
  ma_click_on_link:
    'Click on the tracking link above each product to track each indiviual parcel. More than one product can be included in a single shipment',
  ma_return_created: 'Return {0}: Created',
  ma_return_history: 'Return History ',
  ma_review_or_track: 'Review or track a return.',
  ma_goto: 'To create a return, go to Order History and select the item(s) you wish to return.',
  ma_no_returns: 'You do not have any returns in progress.',
  ma_return_details: 'Return details ',
  ma_please_note: 'WE CANNOT REFUND ANY SHIPMENT CHARGES, GIFT WRAPPING OR PROMOTIONS APPLIED TO YOUR ORIGINAL ORDER.',
  ma_shipment_charge: 'Shipment charge: ',
  ma_return_info: 'Return Information',
  ma_return_date: 'Return Date',
  ma_return_address: 'Return Address',
  ma_return_method: 'Return Method ',
  ma_additional_info: 'Additional return information',
  ma_return: 'Return',
  ma_return_instructions_1: ' Items can be returned online or in store.',
  ma_return_instructions_2:
    'To return an item online, print the return label provided and ship the item back to us. You’ll receive an email once we receive your parcel. If there’s an issue with your return you will be contacted by our team.',
  ma_return_instructions_2_boris:
    'To return an item online, print the return label provided and ship the item back to us. You’ll receive an email once we receive your parcel. If there’s an issue with your return you will be contacted by our team.',
  ma_return_instructions_3:
    'To return an item in store, simply bring your item to a store near you and our associates will process your return.',
  ma_return_instructions_4:
    'NOTE: It is not possible to return an item in store if you have already begun the online return process.',
  ma_return_instructions_4_boris:
    'NOTE: It is not possible to return an item in store if you have already begun the online return process.',
  ma_receive_email:
    'You’ll receive a notification email once we receive your parcel. If there is an issue with your return you’ll be contacted by our team.',
  ma_replace: 'Replace',
  ma_replace_once_verified:
    'If you need to replace an item, you will receive a replacement once your return is received and verified. For additional information contact us: ',
  ma_refund: 'Refund',
  ma_refund_note:
    'Please note: After verifying your return, we will refund the amount paid to your original payment method. The refund will appear as a credit on your billing statement according to your card provider.',
  ma_credit_card_method: '- Credit card payment: typically within 2-4 business days',
  ma_paypal_method: '- PayPal express: typically within 2-4 business days',
  ma_partial_method:
    '- Partially/complete gift card payment: typically within 2 business days. Your refund will be returned to the gift card used to make the original payment ',
  ma_refund_note_boris:
    'Please note: After verifying your return, we will refund the amount paid to your original payment method. The refund will appear as a credit on your billing statement according to your card provider.',
  ma_credit_card_method_boris: '- Credit card payment: typically within 2-4 business days',
  ma_paypal_method_boris: '- PayPal express: typically within 2-4 business days',
  ma_partial_method_boris:
    '- Partially/complete gift card payment: typically within 2 business days. Your refund will be returned to the gift card used to make the original payment ',
  ma_return_in_progres: 'Return {0}: In progress ',
  ma_return_completed: 'Return {0}: Completed',
  ma_return_rejected: 'Return {0}: Rejected',
  ma_hnu_just_for_you: 'Just for you',
  ma_hnu_complete_details: 'Complete your account details',
  ma_hnu_personalized_experience: 'for a personalized shopping experience.',
  ma_hnu_complete_profile: 'Complete profile ',
  ma_hnu_your_special_offers: 'YOUR SPECIAL OFFERS',
  ma_hnu_use_code: 'Use Code to get $50 off $200',
  ma_hnu_start_shopping: 'Start shopping ',
  ma_hnu_shop_exclusive_products: 'Shop exclusive products',
  ma_hnu_shop_now: 'Shop now',
  ma_hnu_in_store_pickup: 'In-store pickup',
  ma_hnu_order_online:
    'Order online & pick up in store in just 2 business hours for free! Add your nearest store location to your profile to have your shades in hand even faster.',
  ma_hnu_select_preferred_store: 'Select preferred store',
  ma_hnu_your_wishlist: 'Your wishlist',
  ma_hnu_see_all_products: 'See all products ',
  ma_hnu_wishlist_empty: 'Your wishlist is empty! Browse our site and save your favorite styles.',
  ma_hnu_your_orders: 'Your order history',
  ma_hnu_your_last_order: 'Your last order',
  ma_hnu_your_last_return: 'Your last return',
  ma_hnu_see_all: 'See all ',
  ma_hnu_your_returns: 'Your return history',
  ma_hnu_no_returns_in_progress: 'You do not have any returns in progress.',
  ma_your_preferred_stores: 'Your preferred stores',
  ma_no_saved_stores: 'You have not saved any stores yet.',
  ma_view_directions: 'View directions',
  ma_opening_hours: 'Opening hours',
  ma_services: 'Services:',
  ma_default_store: 'This is your default store',
  ma_delete: 'Delete',
  ma_harg_add_a_giftcard: 'Add a giftcard',
  ma_harg_card_number: 'Card number',
  ma_harg_pin_number: 'Pin number',
  ma_harg_add_card: 'Add card',
  ma_harg_are_you: 'Are you sure you want to remove this gift card from your account?',
  ma_hnu_remove_card: 'Remove card from account',
  ma_hnu_keep_card: 'Keep card',
  ma_hnu_your_giftcards: 'Your gift cards',
  ma_hnu_manage_giftcard: 'Manage gift cards and e-gift cards and check your balance',
  ma_hnu_add_giftcard: 'Add a gift card to your account',
  ma_hnu_add_existing_giftcard:
    'Add an existing gift card to your account and check your balance. ',
  ma_hnu_add_card: 'Add card',
  ma_hnu_looking_giftcard: 'Looking to buy a gift card?',
  ma_hnu_shop_gifts: 'Shop Sunglass Hut gift cards and e-gift cards',
  ma_hnu_redeemable: 'redeemable online and in store.',
  ma_hnu_shop_giftcards: 'Shop gift cards',
  ma_hnu_shop_egiftcards: 'Shop e-gift cards',
  ma_hnu_card_number: 'Card number ',
  ma_hnu_pin_number: 'Pin number',
  ma_hnu_balance: 'Balance',
  ma_hnu_your_purchases: 'Your purchases',
  ma_hnu_egiftcard: 'E-Gift card',
  ma_hnu_resend_card: 'Resend card via email',
  ma_hnu_check_balance: 'Check balance updates',
  ma_hnu_giftcard_no_purchases: 'You have not made any purchases with this gift card. ',
  ma_hnu_complete_email_title: 'Verify your email to unlock the full experience',
  ma_hnu_complete_email_subtitle:
    'Your account is limited. To get full access, please verify your email by clicking "Verify email". In case of issues, please contact us at 1-800-786-4527',
  ma_hnu_complete_email_cta: 'Verify your email',
  ma_csg_delivery: 'Delivery',
  ma_csg_payment: 'Payment ',
  ma_csg_total_amount: 'Total amount',
  ma_csg_have_giftcard: 'Have a gift card? ',
  ma_csg_add_giftcard: 'Add a gift card',
  ma_csg_card_number: 'Card number',
  ma_csg_pin_number: 'Pin number',
  ma_csg_whats_this: 'What\'s this? ',
  ma_csg_card_details: 'Card details ',
  ma_csg_name_on_card: 'Name on card ',
  ma_csg_expiration_date: 'Expiration date ',
  ma_csg_cvv: 'Cvv',
  ma_csg_pay_and_confirm: 'Pay & confirm order ',
  ma_csg_order_summary: 'Order Summary',
  ma_csg_subtotal: 'Subtotal',
  ma_csg_shipping_cost: 'Shipping cost',
  ma_csg_tax: 'Tax',
  ma_total: 'Total',
  ma_csg_delivery_details: 'Delivery Details',
  ma_csg_estimated_date: 'Estimated Delivery Date:',
  ma_csg_estimated_date_custom: 'Estimated Delivery Date for customized products',
  ma_csg_deliver_to: 'Deliver to:',
  ma_csg_items_in_cart: 'Items in your cart',
  ma_csg_card_not_found: 'We did not find your card number. Where is my card number located?',
  ma_csg_incorrect_pin: 'Your pin number is incorrect. Where can I find my pin number?',
  ma_csg_giftcard_number_location:
    'Your 16-digit gift card number is located on the back side of the card at the very bottom.',
  ma_csg_card_pin_location: 'Your 8-digit pin number is located on the back side of the card. ',
  ma_wl_out_of_stock: 'Out of stock',
  ma_wl_find_a_store: 'Find in store',
  ma_add_to_bag: 'Add to bag',
  ma_wnl_login_wishlist: 'Log in',
  ma_wnl_your_isempty: 'Your wishlist is empty!',
  ma_wnl_browse: 'Browse our site and save your favorite styles',
  ma_wnl_start_shopping: 'Start shopping',
  ma_wnl_login_see_items: 'Log in to see your saved items',
  ma_shared_wishlist: 'Shared Wishlist',
  ma_sharer: '{0}\'s wishlist',
  ma_your_wishlist: 'Your wishlist',
  ma_wnl_signup_or_login: 'Create an account or log in to manage your wishlist and save new items',
  ma_share_wishlist: 'Share your wishlist!',
  ma_wl_email_me: 'Email me when available',
  ma_signin_add_bag: 'Sign in and add to bag',
  ma_wnl_login_add_bag: 'Log in and add to bag',
  ma_page_unavailble: 'Sorry, this page is no longer available',
  ma_wl_link_expired:
    'The link has expired or this list is no longer available. Browse our site to save styles to your wishlist.',
  ma_wml_check_my_wishlist: 'Check out my SunglassHut wishlist!',
  ma_wml_shop_favorite: 'Shop my favorite styles at:',
  ma_breadcrumb_details: 'PROFILE DETAILS',
  ma_breadcrumb_orderHistory: 'Order History',
  ma_breadcrumb_returnHistory: 'Return History',
  ma_pdi_your_profile: 'Your profile ',
  ma_pdi_manage_account:
    'Manage information related to your account, personal details and preferred store locations',
  ma_pd_pInfo: 'Personal information',
  ma_pdi_complete_your_info: 'Complete your personal information',
  ma_pd_edit: 'Edit',
  ma_pdi_first_name: 'First name',
  ma_pdi_last_name: 'Last name',
  ma_pdi_gender: 'Gender',
  ma_pdi_birthdate: 'Birthdate',
  ma_pdi_phone: 'Phone number',
  ma_pdi_complete_your_profile: 'Complete your profile',
  ma_pd_lInfo: 'Login information',
  ma_pdi_change_email: 'Change email ',
  ma_pdi_email: 'Email',
  ma_sup_password: 'Password',
  ma_pd_edit_password: 'Edit password',
  ma_pd_edit_address: 'Edit address',
  ma_pd_addressBook: 'Address book',
  ma_pd_addAddress: 'Add an address',
  ma_pdi_no_addresses: 'You haven’t saved any addresses yet.',
  ma_pdi_add_automatic_address:
    'Add an address and save it as default to automatically fill in your shipping information at checkout. ',
  ma_pdi_save_automatic_address:
    'Save your address as default to automatically fill in your shipping information at checkout. ',
  ma_pdi_prefered_stores: 'Your preferred stores',
  ma_add_store: 'Add store',
  ma_add_store_favourites: 'Add store to favorites',
  ma_closed_store_favourites: 'Closed',
  ma_pdi_no_stores_saved: 'You have not saved any stores yet.',
  ma_pdi_contanct_preferences: 'Communication preferences',
  contact_phone_title: 'Mobile',
  ma_newsletter_preferences: 'Newsletter preferences',
  ma_sup_email_consent:
    'By checking the box, you consent to receive emails about our latest collections and exclusive offers. You can change your mind and unsubscribe any time. By proceeding you confirm that you’ve read and understood our {placeholderLink}.',
  ma_loyalty_communications: 'Subscribe to receive our Loyalty program communications',
  ma_pdi_add_new_address: 'Add a new address',
  ma_pdi_set_default_delivery: 'Set as default delivery address',
  ma_pdi_your_default_billing_address: 'This is your default billing address',
  ma_pdi_your_default_delivery_address: 'This is your default delivery address',
  ma_pdi_default_store: 'This is your default store',
  ma_pdi_set_default_billing: 'Set as default billing address',
  ma_pdi_pickup_or_book: 'Services:     Pick up in store | Book an appointment',
  ma_pdi_update_personal_info: 'Update your personal information',
  ma_pdi_save_profile: 'Save profile',
  ma_epo_update_password: 'Update your password',
  ma_epo_current_password: 'Current password',
  ma_epo_new_password: 'New password',
  ma_epo_confirm_password: 'Confirm new password',
  ma_epo_save_password: 'Save password',
  ma_eeo_change_address: 'Change email address',
  ma_eeo_new_address: 'New email address',
  ma_eeo_save_email: 'Save email ',
  ma_aao_update_address: 'Update your address',
  ma_aao_phoneNumber: 'Phone number',
  ma_aao_privacy_usage: 'Only used for information related to your order status',
  ma_aao_street_address: 'Street address ',
  ma_aao_please_check_address:
    'Please make sure your address is correct and contains the street number',
  ma_aao_apartment_floor: 'C/O, Apartment, Floor (optional)',
  ma_aao_zipcode: 'Zip code',
  ma_aao_city_or_code: 'City (or APO/FPO)',
  ma_aao_state: 'State (or AA/AE/AP)',
  ma_aao_country: 'Country',
  ma_aao_unsaved_details: 'Unsaved details',
  ma_aao_save_exit: 'Save and exit',
  ma_aao_leave_saving: 'Leave without saving',
  ma_enter_location: 'Enter location',
  ma_enter_your_location: 'Enter your location',
  ma_view_all_stores: 'View all Sunglass Hut stores',
  ma_aao_save_address: 'Save address',
  ma_aao_delete_address: 'Delete address',
  ma_aao_delete_address_confirm: 'Are you sure you want to delete this address?',
  ma_aao_yes_delete_address: 'Yes, delete address',
  ma_aao_no_keep_address: 'No, keep address',
  ma_set_default_store: 'Set as default store',
  ma_delete_store: 'Delete favorite store',
  ma_delete_store_confirm: 'Are you sure you want to delete this store?',
  ma_yes_delete_store: 'Yes, delete store',
  ma_keep_store: 'No, keep store',
  ma_ss_pickup_in_store: 'IN-STORE PICKUP - FREE',
  ma_ss_collect_in_store: 'Buy online and collect in store. Available 2 hours after purchase.',
  ma_ss_select_preferred_store: 'Select your preferred store',
  ma_fs_find_in_store: 'Find in store ',
  ma_fs_your_item: 'Your item ',
  ma_fs_your_store: 'Your Sunglass Hut store:',
  ma_fs_book_appointment_discover: 'Book an appointment to discover the Stella experience ',
  ma_fs_call_to_reserve: 'Call to reserve it for 24h',
  ma_fs_favorite_store: 'Favorite store',
  ma_fs_removed_from_stores: 'Removed from favorite stores',
  ma_fs_added_to_stores: 'Added to favorite stores',
  ma_fs_change_location: 'Change location',
  ma_fs_find_store: 'Find a Sunglass Hut store ',
  ma_fs_enter_location: 'Enter a location (zip code, address or city) ',
  ma_fs_safe_stores_description:
    'We have recently opened stores in areas which are considered safe to conduct business. In these newly re-opened stores we are taking extra precautionary measures to ensure the best interests of our customers and our workers. In-store Pickup will be available at selected locations, check for service availability in your area within the checkout. We remain open 24/7 online at www.sunglasshut.com Stay healthy and keep looking forward to sunny skies ahead.',
  ma_fs_sgh_stores: 'Sunglass Hut Stores ',
  ma_fs_preferred_store: 'Preferred store',
  ma_fs_appointment_in_store: 'Appointment in store',
  ma_in_store_appointments: 'In-store appointments',
  ma_book_with_consultants:
    'Book an in-store appointment with our style consultants for a personalized shopping experience based on your needs!',
  ma_no_appointments: 'You have not booked any appointments. ',
  ma_fs_upcoming_appointments: 'Upcoming appointments',
  ma_select_calendar: 'Select your calendar',
  ma_apple_calendar: 'Apple Calendar',
  ma_google_calendar: 'Google Calendar',
  ma_outlook_calendar: 'Outlook',
  ma_add_calendar: 'Add to calendar',
  ma_fs_reschedule: 'Reschedule',
  ma_fs_cancel: 'Cancel',
  ma_fs_visit_purpose: 'VISIT PURPOSE',
  ma_fs_location: 'LOCATION',
  ma_fs_view_contact_info: 'Your contact info',
  ma_fs_past_appointments: 'Past appointments',
  ma_fs_cancel_appointment: 'Cancel appointment',
  ma_fs_cancel_confirmation: 'Are you sure you want to cancel?',
  ma_fs_keep_appointment: 'Keep appointment',
  ma_appointment_booking: 'Appointment booking',
  ma_book_preferred_store: 'Want to book the appointment at your preferred store?',
  ma_book_this_store: 'Book at this store',
  ma_choose_another_store: 'Choose another store',
  ma_select_a_store: '1. SELECT A STORE',
  ma_choose_appointment_type: '2. CHOOSE AN APPOINTMENT TYPE',
  ma_choose_date_and_time: '3. CHOOSE A DATE AND TIME',
  ma_save_on_calendar: '4. ADD IT TO YOUR CALENDAR',
  ma_fs_first_name: 'Please provide your first name.',
  ma_fs_last_name: 'Please provide your last name.',
  ma_fs_enter_valid_date: 'Please enter a valid date in format: MM/DD/YYYY',
  ma_fs_email_format: 'Please enter your email address in format: yourname@example.com',
  ma_fs_already_signup: 'It looks like you already have an account. Log in',
  ma_fs_enter_new_password: 'Please enter your new password ',
  ma_fs_verify_password: 'Please verify and re-enter your password ',
  ma_fs_enter_password_again: 'Please re-enter your password.',
  ma_fs_credentials_problem:
    'There is a problem with the email address and/or password you entered. Please try again.',
  ma_fs_email_not_mach: 'This email does not match any accounts on record. Create an account here',
  ma_fs_password_incorrect: 'This password is incorrect. Please try again. ',
  ma_fs_login_impossible: 'It was not possible to log into your account.',
  ma_fs_try_again: 'Please try again. ',
  ma_fs_email_not_in_database: 'This email is not in our database. Create an account here',
  ma_fs_password_reset_success: 'Your password was reset successfully!',
  ma_fs_login_below: 'Log into your account below.',
  ma_email: 'Email address',
  ma_password: 'Password',
  ma_firstName: 'Name',
  ma_lastName: 'Surname',
  ma_gender_select_message: 'Select your gender:',
  ma_phoneNumber: 'Phone number',
  ma_newEmail: 'New email address',
  ma_currentPassword: 'Current password',
  ma_newPassword: 'New password',
  ma_confirmPassword: 'Confirm new password',
  ma_streetAddress: 'Street address',
  ma_addressApartment: 'C/O, Apartment, Floor (optional)',
  ma_zipCode: 'Zip code',
  ma_city: 'City (or APO/FPO)',
  ma_state: 'State (or AA/AE/AP)',
  ma_country: 'Country',
  ma_default_delivery_address: 'Set as default delivery address',
  ma_default_billing_address: 'Set as default billing address',
  ma_no_to_say_option: 'Prefer not to say',
  ma_female: 'Female',
  ma_choose_password: 'Choose a password that\'s hard to guess but easy to remember.',
  ma_password_must_include: 'Your password must include at least:',
  ma_val_minimumPasswordLength: '{0} character',
  ma_val_minimumPasswordLength_plural: '{0} characters',
  ma_val_minUppercase: '{0} uppercase letter (A-Z)',
  ma_val_minUppercase_plural: '{0} uppercase letters (A-Z)',
  ma_val_minLowercase: '{0} lowercase letter (a-z)',
  ma_val_minLowercase_plural: '{0} lowercase letters (a-z)',
  ma_val_minimumNumeric: '{0} number (0-9)',
  ma_val_minimumNumeric_plural: '{0} numbers (0-9)',
  ma_val_minimumSpecialCharacter: '{0} special character (!£#)',
  ma_val_minimumSpecialCharacter_plural: '{0} special characters (!£#)',
  ma_verify_password: 'Verify password',
  ma_pwd_error_generic: 'The password doesn\'t meet the requirements',
  ma_pwd_error_old: 'New password cannot be the same as your old password',
  ma_pwd_error_matchUserId: 'Password cannot be the same as your username',
  ma_pwd_error_maximumConsecutiveType:
    'Password cannot contain more than {0} of the same characters in row',
  ma_pwd_error_maximumInstances: 'Password cannot contain more than {0} of the same characters',
  ma_pwd_expired: 'Your password has expired. Update your password before logging in. ',
  ma_male: 'Male',
  ma_invalid_email_message: 'Please provide a valid email address.',
  ma_address_error: 'Please provide a valid address.',
  ma_city_error: 'Please provide a valid city',
  ma_state_error: 'Please provide a valid state',
  ma_country_error: 'Please provide a valid country',
  ma_name_error: 'Please provide a valid name',
  ma_date_error_day: 'error day',
  ma_date_error_month: 'error month',
  ma_date_error_year: 'error year',
  ma_not_alpha_message: 'Make sure to only use numbers',
  ma_not_phone_message: 'Phone number must be 10 digits; only numbers; no spaces; no characters',
  ma_not_zip_message: 'Please provide a valid ZIP code',
  ma_password_message: 'Passwords should be between 6 and 12 characters',
  ma_invalid_password_message:
    'Your password must be between 6 and 12 characters long and is case sensitive',
  ma_invalid_password_match_message: 'The passwords don’t match',
  ma_min_age_message: 'You must be at least 18 years old to register on {placeholderLink}',
  ma_min_age_link: 'https://www.sunglasshut.com',
  ma_item_deleted_wishlist: 'The product has been removed from your wishlist.',
  ma_undo: 'Undo',
  ma_expired_link: 'The link to reset your password has expired',
  ma_request_link: 'Please request a new one.',
  ma_new_link: 'Send new link',
  ma_apartment_error: 'Please provide a valid C/O, Apartment, Floor',
  ma_unavailable_products: 'Unavailable products',
  ma_perfect_shades: 'Find your perfect shades',
  ma_perfect_shades_message: 'Find your perfect shades with our frame advisor technology',
  ma_get_started: 'Get started',
  ma_frame_advisor_messagge:
    'Let our frame advisor technology find the best style for your face shape & tastes!',
  ma_returnflow_phone: 'Phone',
  ma_returnflow_phone_value: '+18007864527',
  ma_returnflow_email: 'Email',
  ma_returnflow_email_value: 'onlinesupport@sghcares.com',
  ma_read_more_description:
    'To change or cancel an order you recently submitted, please simply give us a call at  <b>1-800-SUNGLAS (786-4527)</b> Monday to Friday 8:30am-5:30pm, Saturday 9:00am-5:30pm, as soon as possible and we will do our best to accommodate your request. </br> </br>However, please be aware that as our system is designed to fulfil orders very quickly. <b>Customers are given one hour to cancel their orders after order placement, </b>but after the first hour we cannot guarantee that it will be possible to cancel or change the order once it has entered the shipping process.',
  ma_img_map: 'USA',
  ma_find_store: 'Find a Store',
  ma_find_store_address: 'Address:',
  ma_find_store_view: 'View all Sunglass Hut Stores',
  ma_find_store_view_link: 'https://stores.sunglasshut.com/',
  ma_goto_loyalty_program: 'GO TO LOYALTY PROGRAM',
  ma_goto_loyalty_program_link: '/myaccount/loyalltyProgram',
  ma_loyalty_program: 'Your loyalty program',
  ma_loyalty_unsubscribe_title: 'We’re sad to see you go!',
  ma_sun_love_title: 'The Sun Club',
  ma_loyalty_unsubscribe_description:
    'By unsubscribing, you’re choosing to cancel your The Sun Club loyalty program membership. You may restore your account within 10 days in your My Account or by clicking ‘Restore The Sun Club subscription’ in the latest email​',
  ma_loyalty_consent_unsubscribe_description:
    'Your email address will be removed from The Sun Club Loyalty program commercial communications mailing list within 10 days. To restore your preferences, you may do so in My Account.',
  ma_sun_points_earn: 'You’ve earned Sun Points! Check your balance.',
  ma_sun_points_loss: 'Sun Points will be deducted from your balance. Find out more.',
  ma_login_loyal_benefits:
    'Log in to track orders, create wishlists and explore The Sun Club benefits.',
  retail_delivery_fees: 'Retail delivery fees',
  ma_loyalty_subscribe_feedback: 'You have successfully subscribed to The Sun Club communications!',
  ma_loyalty_unsubscribe_feedback:
    'You have successfully unsubscribed from The Sun Club communications!',
  ma_pick_up_in_store_link:
    'https://www.sunglasshut.com/us/sunglasses/services-for-you?pickupinstore',
  ma_call_and_reserve_link:
    'https://www.sunglasshut.com/us/sunglasses/services-for-you?callandreserve',
  ma_book_an_appointment_link: 'https://www.sunglasshut.com/us/sunglasses/services-for-you',
  ma_book_an_appointment: 'Book an appointment',
  ma_call_and_reserve: 'Call to reserve it for 24h',
  ma_call_and_reserve_aria_label: 'Call to reserve it for 24 hours opens in new window',
  ma_pick_up_in_store: 'Pickup in store',
  ma_sl_link_with_book_appointment: '/us/sunglasses/store-locations?bookingAvailable=true',
  ma_expired_password: 'Your password has expired.',
  ma_update_password: 'Update your password here',
  email_verification_cofirmation: 'Your email has been confirmed successfully',
  email_verification_cofirmation_body:
    'Your account has been activated, start browsing the website by clicking on {placeholderLink}',
  email_verification_cofirmation_button: ' Start Shopping.',
  email_verification_expired: 'Ops, the link is no longer active.',
  email_verification_expired_body: 'Generate a new one by clicking on the button below.',
  resend_email: 'Resend email',
  ma_join_title: 'Create an account',
  ma_check_inbox: 'Check your inbox',
  ma_check_inbox_body:
    'We’ve sent you an email. Please check your inbox and confirm your account. If you haven\'t received anything, click on {placeholderLinkResendEmail}.',
  loyalty_banner_cta_join: 'Create account & join',
  loyalty_banner_cta_open_benefits: 'Redeem benefits',
  loyalty_banner_cta_restore: 'Restore the sun club subscription',
  loyalty_banner_title_member: 'Reedem your sun club benefits',
  loyalty_banner_title_guest: 'Earn {0} loyalty points',
  loyalty_banner_title_not_verified: 'Check your inbox',
  loyalty_banner_title_on_hold: 'Loyalty program on hold',
  loyalty_banner_description_guest:
    'Create an account & join The Sun Club to earn points on this purchase.',
  loyalty_banner_description_logged:
    'Join The Sun Club at checkout to earn points on this purchase.',
  loyalty_banner_description_member:
    'Check out your active benefits or proceed with the purchase to <strong>earn {0} Sun Points</strong>.',
  loyalty_banner_description_just_member:
    'Congrats, you’re part of The Sun Club! You’ll earn {0} Sun Points by joining.',
  loyalty_benefits_title: 'Your benefits',
  loyalty_benefits_subtitle:
    'Redeem your active benefits as part of The Sun Club program. Benefits will be applied to your current cart.',
  loyalty_benefits_warning: 'You can only redeem one benefit at time.',
  date_error: 'To proceed you must be of legal age',
  loyalty_benefits_empty:
    'You’ve already unlocked all your benefits or you don’t have any to redeem yet. Check for any additional benefits in MyAccount and keep earning more points to get to the next level!',
  loyalty_terms: 'The Sun Club Terms and Conditions',
  loyalty_banner_description_member_empty_cart:
    'Check out your active benefits and redeem them today.',
  loyalty_banner_description_not_verified:
    'We\'ve sent you an email. Please check your inbox and confirm your account to <strong>redeem your benefit</strong>.<br>Proceed with the purchase to <strong>earn {0} Sun Club points</strong>.',
  loyalty_banner_description_on_hold:
    'Restore your account to <strong>earn {0} Sun Points</strong> and check out your benefits.',
  ma_sun_love_protection: 'Added {placeholderLink}.',
  ma_sun_love_protection_link: '/us/sunglasses/sun-love-protection-plan',
  ma_sun_love_protection_label: 'Sun Love Protection',
  ma_dialog_alert_0: 'Delete address dialog',
  ma_dialog_alert_1: 'Complete profile dialog',
  ma_dialog_alert_2: 'Find a store dialog',
  ma_dialog_alert_3: 'Delete favorite store dialog',
  ma_dialog_alert_4: 'Update your personal information dialog',
  ma_dialog_alert_5: 'Change email address dialog',
  ma_dialog_alert_6: 'Update your password dialog',
  ma_dialog_alert_7: 'Get Started dialog',
  ma_dialog_alert_8: 'Add an address',
}
